module.exports = {
  'en': {
    'HRES8AXC1': {
      '10': 'Tax year',
      '20': 'total income of year',
      '30': 'Tax deductions paid',
      '40': 'Total revenue of the year',
      '50': 'Salary / wages (per month)',
      '60': 'Annual Cumulative Income',
      '70': 'Other income',
      '80': 'Baht',
      '90': 'Income'
    },
    'HRES8AXC2': {
      '10': 'Deductions and donations',
      '20': 'Reduced Items',
      '30': 'Donation',
      '40': 'Amount',
      '50': 'Benefits',
      '60': 'Terms & Conditions',
      '70': 'Relationship criterion',
      '80': 'Reduce'
    },
    'HRES8AXC3': {
      '10': 'Investment plan',
      '20': 'Tax increase',
      '30': 'Donation',
      '40': 'LTF tax saving fund',
      '50': 'RMF tax saving fund',
      '60': 'General insurance premiums',
      '70': 'Pension insurance premiums',
      '80': 'Maximum rights not exceed.',
      '90': 'Buy LTF Tax Savings Fund',
      '100': 'Buy RMF Tax Savings Fund',
      '110': 'Baht',
      '120': 'Plan'
    },
    'HRES8AXC4': {
      '10': 'Tax summary of year',
      '20': 'Tax rate',
      '30': 'Tax payable',
      '40': 'All earnings',
      '50': 'Allowance',
      '60': 'Baht',
      '70': 'Summary'
    }
  },
  'th': {
    'HRES8AXC1': {
      '10': 'ปีที่คำนวณภาษี',
      '20': 'รายได้รวมประจำปี',
      '30': 'ภาษีหัก ณ ที่จ่าย',
      '40': 'รายได้ทั้งหมดของปี',
      '50': 'เงินเดือน/ค่าจ้าง(ต่อเดือน)',
      '60': 'รายได้สะสมประจำปี',
      '70': 'รายได้อื่นๆ',
      '80': 'บาท',
      '90': 'รายได้'
    },
    'HRES8AXC2': {
      '10': 'ลดหย่อนและเงินบริจาค',
      '20': 'รายการลดหย่อน',
      '30': 'เงินบริจาค',
      '40': 'จำนวนเงิน',
      '50': 'สิทธิประโยชน์ที่ได้รับ',
      '60': 'เงื่อนไขการรับสิทธิ',
      '70': 'เกณฑ์ความสัมพันธ์',
      '80': 'ลดหย่อน'
    },
    'HRES8AXC3': {
      '10': 'วางแผนลงทุน',
      '20': 'รายการลดหย่อน',
      '30': 'ประหยัดภาษีเพิ่มขึ้น',
      '40': 'กองทุนประหยัดภาษี LTF',
      '50': 'กองทุนประหยัดภาษี RMF',
      '60': 'เบี้ยประกันชีวิตทั่วไป',
      '70': 'เบี้ยประกันชีวิตบำนาญ',
      '80': 'ใช้สิทธิสูงสุดไม่เกิน',
      '90': 'ซื้อกองทุนประหยัดภาษี LTF',
      '100': 'ซื้อกองทุนประหยัดภาษี RMF',
      '110': 'บาท',
      '120': 'วางแผน'
    },
    'HRES8AXC4': {
      '10': 'สรุปภาษีประจำปี',
      '20': 'อัตราภาษีสูงสุด',
      '30': 'ภาษีที่ต้องจ่าย',
      '40': 'รายได้ทั้งหมด',
      '50': 'ค่าลดหย่อนทั้งหมด',
      '60': 'บาท',
      '70': 'สรุป'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres8ax.js